import {
	MESSAGES_FETCH, MESSAGES_SUCCESS,
	MESSAGES_FAILURE, MESSAGES_RESET,
	SAVE_MESSAGES, RESTORE_MESSAGES
} from '../actions/MessagesviewActions';
import { LOADING_BEHAVIOR } from '../actions/InfiniteScrollActions';
import merge from 'lodash/merge';
import union from 'lodash/union';

const initialState = {
	isFetching: false,
	loaded: false,
	lastError: '',
	entities: {},
	pages: [],
	result: {
		pms: [],
		pmfolders: [],
		users: []
	},
	pmroute: '',
	id: null
};

export default function messagesview( prevState = initialState, action ) {

	switch( action.type ) {
		case MESSAGES_FETCH:
			return Object.assign({},
				prevState,
				{
					isFetching: true,
					// Only set loaded to false if we are doing a full refresh
					loaded: !( action.loadingBehavior === LOADING_BEHAVIOR.REFRESH )
				});

		case MESSAGES_SUCCESS:
			if(
				prevState.pmroute !== action.pmroute ||
				prevState.id !== action.id ||
				action.loadingBehavior === LOADING_BEHAVIOR.REFRESH
			) {
				return merge(
					{},
					action.data,
					{
						lastError: '',
						isFetching: false,
						loaded: true,
						id: action.id,
						pmroute: action.pmroute,
						pages: [parseInt( action.data.page )]
					},
					{
						prevState: prevState.prevState
					}
				);

			} else {
				let pmsResult, usersResult, pages;

				if( action.loadingBehavior === LOADING_BEHAVIOR.PREPEND ) {
					pmsResult = [...action.data.result.pms, ...prevState.result.pms];
					usersResult = union(action.data.result.users, prevState.result.users);
					pages = [parseInt( action.data.page ),...prevState.pages];
				} else if( action.loadingBehavior === LOADING_BEHAVIOR.APPEND ) {
					pmsResult = [...prevState.result.pms, ...action.data.result.pms];
					usersResult = union(prevState.result.users, action.data.result.users);
					pages = [...prevState.pages, parseInt( action.data.page )];
				}

				return merge(
					{},
					prevState,
					action.data,
					{
						lastError: '',
						isFetching: false,
						loaded: true
					},
					{
						pages: pages,
						result: {
							pms: pmsResult,
							users: usersResult
						}
					}
				);
			}

		case MESSAGES_FAILURE:
			return Object.assign({}, prevState, {
				lastError: action.error,
				isFetching: false,
				loaded: false
			});

		case MESSAGES_RESET:
			return initialState;

		case SAVE_MESSAGES:
			return {
				...prevState,
				prevState: prevState
			};

		case RESTORE_MESSAGES:
			return prevState.prevState||initialState;

		default :
			return prevState;
	}
}




// WEBPACK FOOTER //
// ./common/reducers/messagesview.js